import { Alarm } from "./Alarm";
import { AlwaysHome } from "./AlwaysHome";
import { Chime } from "./Chime";
import { ChimePro } from "./ChimePro";
import { FloodlightCam } from "./FloodlightCam";
import { FloodlightCamOn } from "./FloodlightCamOn";
import { LightOn } from "./LightOn";
import { MotionPerson } from "./MotionPerson";
import { Onvif } from "./Onvif";
import { Rvd } from "./Rvd";
import { Rvd2 } from "./Rvd2";
import { RvdElite } from "./RvdElite";
import { RvdPro } from "./RvdPro";
import { SpotlightCam } from "./SpotlightCam";
import { SpotlightCamOn } from "./SpotlightCamOn";
import { StickupCam } from "./StickupCam";
export var DEVICE_ICON_MATCH = Object.freeze({
  base_station_k1: Alarm,
  base_station_v1: Alarm,
  beams_bridge_v1: Alarm,
  beams_c20_motion_sensor: MotionPerson,
  beams_c30_spotlight: SpotlightCamOn,
  beams_c40_steplight: LightOn,
  beams_c50_pathlight: LightOn,
  beams_c3500_spotlight: SpotlightCamOn,
  beams_c5000_floodlight: FloodlightCamOn,
  beams_ct200_transformer: LightOn,
  chime: Chime,
  chime_pro: ChimePro,
  cocoa_camera: StickupCam,
  cocoa_floodlight: FloodlightCam,
  doorbell: Rvd,
  doorbell_graham_cracker: RvdPro,
  doorbell_oyster: RvdPro,
  doorbell_portal: RvdPro,
  doorbell_scallop: RvdPro,
  doorbell_scallop_lite: Rvd2,
  doorbell_v3: Rvd,
  doorbell_v4: Rvd,
  doorbell_v5: Rvd,
  doorbot: Rvd,
  floodlight_v2: FloodlightCam,
  floodlight_pro: FloodlightCam,
  hp_cam_v1: FloodlightCam,
  hp_cam_v2: SpotlightCam,
  jbox_v1: RvdElite,
  lpd_v1: RvdPro,
  lpd_v2: RvdPro,
  lpd_v4: RvdPro,
  onvif_camera: Onvif,
  spotlightw_v2: SpotlightCam,
  stickup_cam: StickupCam,
  stickup_cam_elite: StickupCam,
  stickup_cam_lunar: StickupCam,
  stickup_cam_mini: StickupCam,
  stickup_cam_v3: StickupCam,
  stickup_cam_v4: StickupCam,
  always_home_camera: AlwaysHome
});
//# sourceMappingURL=constants.js.map